function initialiseConsumerDisclaimer () {
  $("#consumer-disclosure-icon").focus(function () {
    $("#consumer-disclosure-tooltip").toggleClass("m-fadeIn");
  });

  $("#consumer-disclosure-icon").focusout(function () {
    if ($("#consumer-disclosure-tooltip").hasClass("m-fadeIn")) {
      $("#consumer-disclosure-tooltip").toggleClass("m-fadeIn");
    };
  });
};

$(function () {
  initialiseConsumerDisclaimer();

  OT.Events.on('results:done', function(){
    initialiseConsumerDisclaimer();
  });
});
